import { Namespace, ReadCallback, ResourceKey } from "i18next";

export const fallbackLng = "cs";
export const languages = [fallbackLng, "en"];
export const defaultNS = "common";
export const namespaces = defaultNS;

export function getOptions(lng = fallbackLng, ns: Namespace = namespaces) {
  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns,
  };
}

export const getResources = async (language: string, namespace: string, callback: ReadCallback) => {
  try {
    const resource = (await import(`./locales/${language}/${namespace}.json`)) as ResourceKey;
    callback(null, resource);
  } catch (e: unknown) {
    if (e instanceof Error) {
      callback(e, null);
    }
  }
};
